// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { getConfig as getAppConfig } from '~/core/state/config/selectors';

export const getEntitlements = (state: {} = {}): fromJS => state.entitlements || fromJS({});

export const getConfig = createSelector(getEntitlements, entitlements => entitlements.get('config'));

export const getSubscriptions = createSelector(getConfig, config => config.get('subscriptions'));

export const hasSMS = createSelector(getConfig, config => !!config.get('SMS'));

const getKey = (_, key) => key;

export const getHasEntitlement = createSelector(getConfig, getKey, (config, key) => !!config.get(key));

export const isLoading = createSelector(getEntitlements, entitlements => !!entitlements.get('loading'));

export const getSubscriptionsByName = createSelector(
    getSubscriptions,
    (_, props) => (props && props.names) || [],
    state => getAppConfig(state, 'subscriptions:types'),
    (subscriptions, names, config) =>
        // $FlowFixMe
        (subscriptions || fromJS([]))
            .filter(subscription => names.includes(subscription.get('name')))
            .filter(
                subscription =>
                    !(
                        subscription.get('status') === 'SUSPENDED' &&
                        !config.get(subscription.get('name')).get('suspendable')
                    )
            )
);



// WEBPACK FOOTER //
// ./src/core/state/entitlements/selectors.js